import React from "react";

import { JobPerformanceMetrics, OverviewCardProps } from "@/types/job";

import { formatBackendKey } from "./helpers";

export const OverviewCard = ({ stages, overall }: OverviewCardProps) => {
  return (
    <div className="my-3 rounded bg-white p-3">
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-5">
        {stages.map((stage) => (
          <div key={stage.key} className="flex flex-col gap-1 text-xs">
            <div className="flex items-center gap-2 truncate text-gray-600">
              <span
                className="h-2 w-2 shrink-0 rounded-full"
                style={{ backgroundColor: stage.color }}
              />
              <span className="truncate">{stage.label}</span>
            </div>

            <div className="text-sm font-semibold text-gray-900">
              {overall[stage.key] ?? 0}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

type TableOverviewCardProps = {
  overall: JobPerformanceMetrics;
};

export const TableOverviewCard: React.FC<TableOverviewCardProps> = ({
  overall,
}) => {
  return (
    <div className="my-3 rounded bg-white p-3">
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-5">
        {Object.entries(overall).map(([key, value]) => (
          <div key={key} className="flex flex-col gap-1 text-xs">
            <div className="flex items-center gap-2 truncate text-gray-700">
              <span className="h-2 w-2 shrink-0 rounded-full bg-gray-400" />
              <span className="truncate">{formatBackendKey(key)}</span>
            </div>
            <div className="text-sm font-semibold text-gray-900">{value}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

type RejectDropOverview = Record<
  string,
  {
    rejected: number | "-";
    dropped: number | "-";
  }
>;

type RejectDropOverviewCardProps = {
  overall: RejectDropOverview;
};

export const RejectDropOverviewCard: React.FC<RejectDropOverviewCardProps> = ({
  overall,
}) => {
  return (
    <div className="my-3 rounded bg-white p-3">
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-5">
        {Object.entries(overall).map(([key, value]) => (
          <div key={key} className="flex flex-col gap-1 text-xs">
            <div className="flex items-center gap-2 truncate text-gray-700">
              <span className="h-2 w-2 shrink-0 rounded-full bg-gray-400" />
              <span className="truncate">{formatBackendKey(key)}</span>
            </div>

            <div className="text-sm font-semibold text-gray-900">
              <span>{value.rejected}</span>
              <span className="mx-1 text-gray-400">|</span>
              <span>{value.dropped}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
